import React from "react";
import { Panel } from "@glamcorner/components/lib/core/components/Panel";
import { ItemLimit } from "@glamcorner/gc-types/lib/subscription";

import "./itemsPerMonth.scss";


export type ItemsPerMonthType = {
  itemLimits: ItemLimit[];
  selected: ItemLimit;
  onClick: (items: ItemLimit) => void;
};

export const ItemsPerMonth: React.FC<ItemsPerMonthType> = ({ itemLimits, selected, onClick }) => {
  return (
    <Panel className="choosePlan-ItemsPerMonth__wrapper">
      {itemLimits.map((itemLimit) => (
        <div
          key={itemLimit}
          style={{ width: `${100 / itemLimits.length}%` }}
          className={`choosePlan-ItemsPerMonth__item ${
            selected == itemLimit ? "choosePlan-ItemsPerMonth__item-selected" : ""
          }`}
          onClick={() => onClick(itemLimit)}
        >
          {itemLimit}
        </div>
      ))}
    </Panel>
  );
};
